module.exports = __webpack_public_path__ + "assets/bgPhoneMobile.8bc3b78a0f55ff808fd7f873ad8548a8.jpg";